import { GET_REPORTS, RESET_REPORTS } from "../../actionTypes/actionsTypes";
import { AppAction, AppNoApiAction, BaseAsyncReducerState } from "../../types";

export interface ReportsState extends BaseAsyncReducerState {
    reports?: Record<string, unknown>;
}
// Define an initial state value for the app
const initialState: ReportsState  = {
    loading: false,
    error: false
}

// Create a "reducer" function that determines what the new state
// should be when something happens in the app
function reportsReducer(state = initialState, action: AppAction | AppNoApiAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case GET_REPORTS.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case GET_REPORTS.SUCCESS:
            return {
                ...state,
                reports: payload,
                loading: false,
                error: false
            }
        case GET_REPORTS.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case RESET_REPORTS:
            return {
                ...state,
                reports: null
            }
        default:
            return state
    }
}

export default reportsReducer;
